// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3kRe1","colBig":"styles_colBig__lV2pR","colSmall":"styles_colSmall__3OjDa"};